export default "__VITE_PUBLIC_ASSET__536933ee__"